


























































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ebInput from "@/components/FormElements/Input.vue";
import axios from "axios";
import { NIPIGE_CAP } from "../../config";

@Component({
  components: {
    ebInput,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class ChangePassword extends Vue {
  private currentpassword = "";
  private newpassword = "";
  private confirmpassword = "";
  private currentPasswordInputType = "password";
  private newPasswordInputType = "password";
  private confirmPasswordInputType = "password";
  private companyName: any =
    JSON.parse(sessionStorage.getItem("companyName") as string) || "NIPIGE";

  async public changePassword() {
    const isValid = await this.$refs.observer.validate();
    if (!isValid) return;
  
    if (sessionStorage.getItem("nipige:forcechangepass")) {
      let type = JSON.parse(
        sessionStorage.getItem("nipige:forcechangepass") as any
      );
      const dataObj = {
        currentPassword: this.currentpassword,
        newPassword: this.newpassword,
      };
      const config = {
        headers: {
          Authorization: type.token,
        },
      };
      type.type === "Tenant"
        ? axios
            .post(`${NIPIGE_CAP}/users/tenant/update-password`, dataObj, config)
            .then((response) => {
              if (response) {
                this.$router.push("login");
              }
            })
            .catch(() => {
              this.$router.push("login");
            })
        : axios
            .post(
              `${NIPIGE_CAP}/users/partner/update-password`,
              dataObj,
              config
            )
            .then((response) => {
              if (response) {
                this.$router.push("login");
              }
            })
            .catch(() => {
              this.$router.push("login");
            });
    }
  }
  public toggleCurrentPasswordVisibility(){
    this.currentPasswordInputType =
        this.currentPasswordInputType === "password" ? "text" : "password";
  }
  public toggleNewPasswordVisibility(){
    this.newPasswordInputType =
        this.newPasswordInputType === "password" ? "text" : "password";
  }
  public toggleConfirmPasswordVisibility(){
    this.confirmPasswordInputType =
        this.confirmPasswordInputType === "password" ? "text" : "password";
  }
}
